<template>
  <el-card class="support">
    <el-row>
      <div class="search">
        <el-input
          type="text"
          placeholder="search for a keyword"
          v-model="search"
          @keyup.enter.native="searchKeyword"
          class="search-box"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchKeyword"></el-button>
        </el-input>
      </div>
    </el-row>
    <el-row v-for="(item, index) in support" :key="index" v-show="item.isShow">
      <div class="question">{{ item.q }}</div>
      <div class="answer">{{ item.a }}</div>
    </el-row>
  </el-card>
</template>

<script>
export default {
  name: 'support',
  data() {
    return {
      search: '',
      support: [
        {
          q: 'How to get your postback URL?',
          a:
            'A postback URL is a simple tracking mechanism and report conversions to your tracker/traffic sources when ' +
            'analyzing the performance of your offers. Please update your postback URL in the channel dashboard and append ' +
            'available macros. We use {aff_sub} for clickid, {source} for your sub publisher/placement, {payout} for payout of each conversions. ',
          isShow: true,
        },
        {
          q: 'How to get the link of different smartlink?',
          a:
            'Currently we support CPI, CPA (carrier billing), CPL and mix smartlink. You can get links from our current ' +
            'smartlink list or it\'s optional to create smartlink by your own.',
          isShow: true,
        },
        {
          q: 'How to create your smartlink?',
          a:
            'You can create your own Smartlink in five simple steps:\n' +
            '1. Select your traffic type: push, pop, display, native, others.\n' +
            '2. Select Mainstream or Adult vertical.\n' +
            '3. Select category: sweepstake, dating, antivirus etc.\n' +
            '4. Click on the "Create Link" button. After this step, a fully functional Smartlink will become available to you.\n' +
            '5. Choose creative for your smartlink if neccessary. At the moment, you can further adjust smartlink and set preference to specific offers which are   most related to creatives.\n' +
            'If you have any difficulties creating your Smartlink, please contact your affiliate manager for assistance.',
          isShow: true,
        },
        {
          q: 'What traffic types do you accept?',
          a:
            'We accept all traffic types and global traffic except fraudulent and incentive traffic.',
          isShow: true,
        },
        {
          q: 'Where can I see smartlink Ecpm report?',
          a:
            'You can go check in smartlink trending dashboard.\n' +
            'Please be aware that because offers and performance change daily, the rates may also vary from different ' +
            'traffic source. We suggest you send enough sample traffic for our algorithm to learn and experiment with your results.',
          isShow: true,
        },
        {
          q: 'Can I see which fixed offers getting converted inside smartlink?',
          a:
            'Yes. you can check it in 2 ways but it\'s open to affiliate only.\n' +
            '1. Go to smartlink trending and click advance data, where you can see converting geos, device and fixed offers.\n' +
            '2. Go check report, select smartlink ID and offers, then you will know converting offers inside.',
          isShow: true,
        },
        {
          q: 'Can I get creatives for smartlink?',
          a:
            'Yes. It’s not suggested to use specific creative for general smartlink. However, if you have selected ' +
            'type of offers for testing, definitively worth to try creative. And it’s supported to choose creative and ' +
            'set prior offers inside smartlink. We provide hot creative for push traffic and redirect traffic at this moment.',
          isShow: true,
        },
        {
          q: 'What\'s the payment terms?',
          a:
            'It varies from CPA to CPI products, general speaking, payment terms is Net 30, minimum payment is $500. ' +
            'Pls update your payment details as soon as you run either smartlink or single campaign. ' +
            'When you reach that threshold for the first time please contact our AM team for confirmation. ' +
            'After your first payment is processed all future payments will go out automatically.',
          isShow: true,
        },
      ],
    }
  },
  methods: {
    searchKeyword() {
      let search = this.search
      let support = this.support
      for (let i = 0, il = support.length; i < il; i++) {
        let str = support[i].q + support[i].a
        let reg = new RegExp('(' + search + ')', 'g')
        support[i].isShow = true
        support[i].isShow = reg.test(str)
      }
    },
  },
}
</script>

<style lang="scss">
.support{
  .search {
    border-bottom: 1px solid #e4e7ed;
    padding-bottom: 25px;
  }
  .search-box {
    width: 480px;
    height: 32px;
    font-size: 14px;
  }
  .question {
    cokor: #37383a;
    margin: 24px 0 8px 0;
    font-weight: 600;
  }
  .answer {
    color: #6b6d71;
    font-size: 14px;
    line-height: 22px;
    border: 1px solid #ebeef5;
    padding: 16px 24px;
    background: #fafcff;
    white-space: pre-line;
  }
}
</style>
